import { formatDateTime, formatDuration, statusPillClass } from "../utils";

const InfoItem = ({ label, children, mono }) => (
  <div className="d_flex flex_column gap_1">
    <span className="audit_info_label">{label}</span>
    <span className={`audit_info_value ${mono ? "audit_mono" : ""}`}>{children ?? "—"}</span>
  </div>
);

const TraceHeaderCard = ({ header, subjectColumns = [] }) => {
  if (!header) return null;

  return (
    <div className="audit_header_card">
      {subjectColumns.map((c) => (
        <InfoItem key={c.idx} label={c.label}>
          {header[`subject_${c.idx}`] || "—"}
        </InfoItem>
      ))}
      <InfoItem label="Actor">
        {header.user_email || "—"}
        {header.user_id ? <span className="audit_mono color_secondary"> ({header.user_id})</span> : null}
      </InfoItem>
      <InfoItem label="Workflow">
        {header.wf_name || "—"}
        {header.wf_id ? <div className="audit_mono color_secondary">{header.wf_id}</div> : null}
      </InfoItem>
      <InfoItem label="Activity">{header.activity_name || header.activity_id || "—"}</InfoItem>
      <InfoItem label="Instance" mono>
        {header.instance_id || "—"}
      </InfoItem>
      <InfoItem label="Status">
        <span className={`status_pill ${statusPillClass(header.status)}`}>{header.status || "—"}</span>
      </InfoItem>
      <InfoItem label="Duration">{formatDuration(header.duration_ms)}</InfoItem>
      <InfoItem label="Started">{formatDateTime(header.started_at)}</InfoItem>
      <InfoItem label="Completed">{formatDateTime(header.completed_at)}</InfoItem>
      <InfoItem label="Trace ID" mono>
        {header.trace_id}
      </InfoItem>
      {header.error && <div className="audit_error_block">{header.error}</div>}
    </div>
  );
};

export default TraceHeaderCard;
